<template>
  <div>
    <mainVue>
      <template v-slot:main="main">
        <videoVue :data-list="main.data"></videoVue>
      </template>
    </mainVue>
  </div>
</template>

<script>
  import mainVue from '../../../components/resource/main.vue'
  import videoVue from '../../../components/resource/video.vue';

  export default {
    name: 'PortalInBooks',
    components: {
      videoVue, mainVue
    },
    data() {
      return {};
    },

    mounted() {
    },

    methods: {},
  };
</script>

<style lang="less" scoped>

</style>
